import { Slide, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { TOPBAR_HEIGHT } from '@/styles/constant';
import { filterdListAtom } from '@/components/devices/Filter';
import Filter from '@/components/devices/Filter';
import DeviceCard from './DeviceCard';

import type { Device } from '@/@types/device';

export const DEVICE_SIDEBAR_WIDTH = 420;
const Layout = styled.div`
  position: absolute;
  top: 0;
  width: ${DEVICE_SIDEBAR_WIDTH}px;
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  background: #F7F9FA;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 2;
  > .deviceList {
      height: auto;
      overflow-y: auto;
  }
`;

export default function Devices() {
  const { t } = useTranslation();
  const location = useLocation();
  const filterdList = useAtomValue(filterdListAtom);

  return (
    <Slide in={location.pathname === '/devices'} direction="right">
      <Layout>
        <div>
          <Typography variant="h5" fontWeight="bold">
            {t('Common.label.devices')}
          </Typography>
          <br />
          <Filter />
        </div>
        <div className="deviceList">
          {filterdList &&
            filterdList.map((device: Device, index: number): JSX.Element => {
              return <DeviceCard key={index} device={device} />;
            })}
        </div>
      </Layout>
    </Slide>
  );
}
